// Mavika Fashion — Shopify theme behaviour
// Handles UI interactions that are not already covered by Liquid forms.

document.addEventListener('DOMContentLoaded', function () {

  // ---- Sticky header shrink on scroll ----
  var header = document.getElementById('siteHeader');
  if (header) {
    var applyScrollState = function () {
      if (window.scrollY > 40) header.classList.add('scrolled');
      else header.classList.remove('scrolled');
    };
    window.addEventListener('scroll', applyScrollState);
    applyScrollState();
  }

  // ---- Quantity stepper (product form) ----
  // Updates the hidden #QuantityInput used by the product add-to-cart form.
  document.querySelectorAll('.qty-row').forEach(function (row) {
    // Bug fix: the cart page (templates/cart.liquid) has its own .qty-row markup
    // built around a *visible* <input type="number"> with its own inline
    // onclick handlers that submit the cart form directly. This generic stepper
    // was also attaching to those rows (children[1].textContent on an <input>
    // is always empty, so it started its own counter at 1) and stomping the
    // input's real value via `visible.value = qty` right as the row's own
    // handler was submitting the form. Skip rows that already manage their own
    // visible number input — this stepper is only for the span+hidden-input
    // pattern used on the product page.
    if (row.querySelector('input[type="number"]')) return;

    var minus = row.children[0];
    var display = row.children[1];
    var plus = row.children[2];
    var hidden = row.querySelector('input[type="hidden"]');
    if (!minus || !display || !plus) return;

    var qty = parseInt(display.textContent, 10) || 1;
    var sync = function () {
      display.textContent = qty;
      if (hidden) hidden.value = qty;
    };
    minus.addEventListener('click', function () {
      qty = Math.max(1, qty - 1);
      sync();
    });
    plus.addEventListener('click', function () {
      qty = Math.min(99, qty + 1);
      sync();
    });
  });

  // ---- Single-select "active" toggles (swatches, FAQ category filter,
  //      payment method picker) ----
  // These three all did the same thing — click an item, clear "active" off
  // its siblings, add it to the one clicked — as three separate near-identical
  // blocks. One small helper replaces all three.
  //   scoped=true  -> siblings are found within the clicked element's parent
  //                   (swatches/categories can repeat in several groups on a page)
  //   scoped=false -> siblings are found across the whole document
  //                   (payment methods: exactly one group per page)
  function wireSingleSelect(selector, scoped) {
    document.querySelectorAll(selector).forEach(function (el) {
      el.addEventListener('click', function () {
        var scope = scoped ? el.parentElement : document;
        scope.querySelectorAll(selector).forEach(function (s) { s.classList.remove('active'); });
        el.classList.add('active');
      });
    });
  }
  // Colour swatch selector (visual state only — wire to a line-item property or
  // a real variant option if you add colour as a Shopify product option)
  wireSingleSelect('.swatch', true);
  // FAQ category filter (visual only, on custom FAQ pages)
  wireSingleSelect('.faq-cat', true);
  // Payment method selector (only relevant if you build a custom
  // Shopify Plus checkout.liquid — standard Shopify checkout is hosted
  // and not themed through this file)
  wireSingleSelect('.pay-option', false);

  // ---- Shop filter active-state toggle (visual only; real filtering is
  //      handled server-side via collection.filters in collection.liquid) ----
  document.querySelectorAll('.filter-group li[data-visual-only]').forEach(function (item) {
    item.addEventListener('click', function () {
      item.classList.toggle('active');
    });
  });

  // ---- Lightweight wishlist (client-side only, via localStorage) ----
  // For a persistent, cross-device wishlist, connect a Shopify wishlist app
  // (e.g. Swym, Wishlist King) or store saved product IDs on a customer metafield.
  var WISHLIST_KEY = 'mavika-fashion-wishlist';
  var getWishlist = function () {
    try { return JSON.parse(localStorage.getItem(WISHLIST_KEY)) || []; }
    catch (e) { return []; }
  };
  var saveWishlist = function (ids) {
    localStorage.setItem(WISHLIST_KEY, JSON.stringify(ids));
  };
  document.querySelectorAll('[data-wishlist-toggle]').forEach(function (btn) {
    var id = btn.getAttribute('data-product-id');
    var ids = getWishlist();
    if (ids.indexOf(id) > -1) { btn.textContent = '♥'; btn.style.opacity = '1'; }

    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      var current = getWishlist();
      var idx = current.indexOf(id);
      if (idx > -1) {
        current.splice(idx, 1);
        btn.textContent = '♡';
        btn.style.opacity = '';
      } else {
        current.push(id);
        btn.textContent = '♥';
        btn.style.opacity = '1';
      }
      saveWishlist(current);
    });
  });

  // ---- Product-card "Quick Add" → Ajax cart drawer ----
  // Bug fix: the quick-add form on product cards (snippets/product-card.liquid,
  // used across the home page, collections, and search results) was a plain
  // Shopify product form with no JS handling, so submitting it caused a full
  // page navigation instead of opening the cart drawer — inconsistent with the
  // rest of the site's "add to cart auto-opens the drawer" behaviour. Delegated
  // listener (works for every card, including ones rendered after this file loads).
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.closest || !form.closest('.pc-quickadd')) return;
    if (typeof window.MvkAddToCart !== 'function') return; // fall back to normal submit
    e.preventDefault();
    var btn = form.querySelector('.pc-quickadd-btn');
    var formData = new FormData(form);
    var payload = {};
    formData.forEach(function (value, key) { payload[key] = value; });
    var originalText = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }
    window.MvkAddToCart(payload)
      .catch(function (err) {
        alert((err && err.description) ? err.description : 'Could not add to bag. Please try again.');
      })
      .then(function () {
        if (btn) { btn.disabled = false; btn.textContent = originalText; }
      });
  });

});
